import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect, OnInitEffects } from '@ngrx/effects';
import { MediaObserver } from '@angular/flex-layout';
import { map, switchMap, tap } from 'rxjs/operators';
import device from 'current-device';

import * as DeviceActions from './device.actions';
import { FlexLayoutMedia } from './device.reducer';
import { Store } from '@ngrx/store';
import { AppState } from '..';

@Injectable()
export class DeviceEffects implements OnInitEffects {
  initDeviceState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.initDeviceState),
      tap(() => {
        const currentDevice: any = device.noConflict();
        const data = {
          deviceWidth: window ? window.innerWidth : undefined,
          deviceHeight: window ? window.innerHeight : undefined,

          isMobile: currentDevice.ios() || currentDevice.android(),
          isDesktop: currentDevice.desktop(),
        };

        this.store.dispatch(
          DeviceActions.setDeviceWidthHeight({
            deviceWidth: data.deviceWidth,
            deviceHeight: data.deviceHeight,
          })
        );
        this.store.dispatch(
          DeviceActions.setCurrentDevice({
            isMobile: data.isMobile,
            isDesktop: data.isDesktop,
          })
        );
      }),
      switchMap(() => {
        return this.mediaService.asObservable().pipe(
          map(() => {
            /*
            https://github.com/angular/flex-layout/wiki/Responsive-API
            breakpoint	mediaQuery
            xs	'screen and (max-width: 599px)'
            sm	'screen and (min-width: 600px) and (max-width: 959px)'
            md	'screen and (min-width: 960px) and (max-width: 1279px)'
            lg	'screen and (min-width: 1280px) and (max-width: 1919px)'
            xl	'screen and (min-width: 1920px) and (max-width: 5000px)'

            lt-sm	'screen and (max-width: 599px)'
            lt-md	'screen and (max-width: 959px)'
            lt-lg	'screen and (max-width: 1279px)'
            lt-xl	'screen and (max-width: 1919px)'

            gt-xs	'screen and (min-width: 600px)'
            gt-sm	'screen and (min-width: 960px)'
            gt-md	'screen and (min-width: 1280px)'
            gt-lg	'screen and (min-width: 1920px)'
            */

            const flexLayoutMedia: FlexLayoutMedia = {
              isExtraSmall: this.mediaService.isActive('xs'),
              isSmall: this.mediaService.isActive('sm'),
              isMedium: this.mediaService.isActive('md'),
              isLarge: this.mediaService.isActive('lg'),
              isExtraLarge: this.mediaService.isActive('xl'),

              isLessThanSmall: this.mediaService.isActive('lt-sm'),
              isLessThanMedium: this.mediaService.isActive('lt-md'),
              isLessThanLarge: this.mediaService.isActive('lt-lg'),
              isLessThanExtraLarge: this.mediaService.isActive('lt-xl'),

              isGreaterThanExtraSmall: this.mediaService.isActive('gt-xs'),
              isGreaterThanSmall: this.mediaService.isActive('gt-sm'),
              isGreaterThanMedium: this.mediaService.isActive('gt-md'),
              isGreaterThanLarge: this.mediaService.isActive('gt-lg'),

              isLandscape: this.mediaService.isActive('landscape'),
              isPortrait: this.mediaService.isActive('portrait'),
              isRetina2: this.mediaService.isActive('retina2'),
              isRetina3: this.mediaService.isActive('retina3'),
              isStandalone: this.mediaService.isActive('standalone'),
            };

            return DeviceActions.flexLayoutMediaObserverEmitted({
              flexLayoutMedia,
            });
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private mediaService: MediaObserver,
    private store: Store<AppState>
  ) {}

  ngrxOnInitEffects() {
    return DeviceActions.initDeviceState();
  }
}
